<template lang="pug">
  v-layout(justify-center)
    v-flex(xs12)
      v-layout(justify-start)
        h2(class="card__title") {{$t('common.btnArchive')}}
      v-data-table(
        :headers="headers",
        :items="archiveReports",
        :loading="loading",
        :no-data-text="$t('common.noSumbitReport')",
        :rows-per-page-text="$t('ReportingPage.PaginationBlock.rowPage')",
        :rows-per-page-items="[10, 25, 50]")
        template(slot="items" slot-scope="props")
          td {{ props.index+1 }}
          td {{ props.item.reportName }}
          td {{ props.item.reportPeriod }}
          td {{ props.item.creationDate }}
          td {{ props.item.reportStatus }}
          td
            a(@click="clickHandler(props.item.reportName, props.item.statReportId, props.item.reportKey)") {{$t('common.checkArchive')}}
        template(v-slot:pageText="props").
          {{$t('ReportingPage.PaginationBlock.noteFrom')}} {{ props.pageStart }}
          {{$t('ReportingPage.PaginationBlock.notePo')}} {{ props.pageStop }}
          {{$t('ReportingPage.PaginationBlock.noteFroms')}} {{ props.itemsLength }}
          {{$t('ReportingPage.PaginationBlock.noteEnd')}}
</template>
<script>
export default {
  name: 'Archive',
  data() {
    return {
      headers: [
        { text: '№', sortable: false },
        { text: this.$t('ReportingPage.SortForm.nameForm'), value: 'reportName', sortable: true },
        { text: this.$t('ReportingPage.SortForm.reportingDate'), value: 'reportPeriod', sortable: true },
        { text: this.$t('ReportingPage.SortForm.reportingCreateDate'), value: 'creationDate', sortable: true },
        { text: this.$t('ReportingPage.SortForm.reportStatus'), sortable: false },
        { text: this.$t('ReportingPage.SortForm.actions'), sortable: false }
      ]
    }
  },
  mounted() {
    this.$store.dispatch('GET_MY_REPORTS')
  },
  computed: {
    archiveReports() {
      return this.$store.state.archive.archiveReports
    },
    loading() {
      return this.$store.state.archive.loading.getMyReports
    }
  },
  methods: {
    clickHandler(title, id, key) {
      this.$store.commit('SET_REPORT_DATA', { title, id, key })
      this.$router.push({ path: `/report/view/${parseInt(id)}` })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MainPage/components/Archive/Archive.vue